import {FunctionComponent, PropsWithChildren} from 'react';

const SlidePanelHeader: FunctionComponent<PropsWithChildren> = ({children}) => {
  return <div className="slide-panel__header">{children}</div>;
};
export default SlidePanelHeader;
